import React, { Component } from 'react'
import './comment.css'

export default class Comment extends Component {
    state={
        comment:'Comment'
    }
    render() {
        return (
            <div className='main'>
            <div className='n_header'>
                <h1>Arriba!</h1>
            </div>
            <div className='n_body'>

               <div className='comment_main'>
<div style={{cursor:'pointer'}} onClick={()=>this.props.history.goBack()}>Back</div>
                   <p>hgdhgd jhdjs jdhjshd jdhjs</p>
                   <input  placeholder='Email' type='email'/>
                   <textarea onChange={(t)=>this.setState({comment:t.target.value})} value={this.state.comment} col="5" row="4"></textarea>
                   <button>Enviar</button>
               </div>

            </div>
            <div className='n_footer'>
                <h3>Thank you for using Arriba!</h3>
            </div>
        </div>
        )
    }
}
